import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Man3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"man_3"}/>
}
